const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args);
	}

	init() {
		if (
			$(this.selector).length > 0 &&
			!$(this.selector).hasClass('slick-initialized')
		) {
			const settings = this.getSlickSettings();

			$(this.selector).slick(settings);
		}
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider', {
	dots: true,
});

const TestimonialSlider = new Slider('.testimonial-slider', {
	dots: true,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 991,
			settings: {
				dots: false,
			},
		},
	],
});

const FluidSlider = new Slider('.gallery-slider__slider-fluid', {
	dots: true,
	centerMode: true,
	variableWidth: true,
    infinite: true,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				centerMode: false,
				variableWidth: false,
				infinite: false,
			},
		},
	],
});

const RelatedPostsSlider = new Slider('.related-posts__slider', {
	mobileFirst: true,
	dots: true,
	responsive: [
		{
			breakpoint: 768,
			settings: 'unslick',
		},
	],
});

const TeamSlider = new Slider('.block-meet-team__slider', {
	mobileFirst: true,
	dots: true,
	slide: '.block-meet-team__slide',
	responsive: [
		{
			breakpoint: 767,
			settings: 'unslick',
		},
	],
});

const FeaturedPrograms = new Slider('.block-featured-programs__slider', {
	dots: true,
	slidesToShow: 3,
	variableWidth: true,
	infinite: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: 'unslick',
		},
	],
});

const BenefitsSlider = new Slider('.block-benefits-image-slider__slider');

const HeroNewsSlider = new Slider('.block-hero__news-wrapper', {
	dots: false,
});

export {
	SimpleSlider,
	TestimonialSlider,
	FluidSlider,
	FeaturedPrograms,
	BenefitsSlider,
	RelatedPostsSlider,
	HeroNewsSlider,
	TeamSlider,
};
